import { useEffect, useRef } from "react"
import Search from "@ciq/shared/components/search"
import eventBus from "@ciq/shared/hooks/eventBus"

/**
 * Map-specific Search wrapper that listens for clear-search events.
 * This scopes the clear-search event to only affect the map's search box,
 * preventing the global clear issue where all search boxes would clear.
 *
 * @param {Object} props - All props are forwarded to the base Search component
 * @returns {React.ReactElement} Search component with clear-search event handling
 */
export function MapSearch(props) {
  const searchRef = useRef(null)

  useEffect(() => {
    const handler = () => {
      searchRef.current?.clear()
    }

    eventBus.on("clear-search", handler)
    return () => eventBus.off("clear-search", handler)
  }, [])

  return <Search ref={searchRef} {...props} />
}
